<template>
  <div style="background: #F5F7FA;margin-bottom: 20px;">
    <el-row>
      <el-col :span="12">
        <div class="pact_left" @mouseenter="showPageBtn" @mouseleave="hidePageBtn">
          <div class="pact_title">
            已盖章合同
            <span v-if="originCurrentPage">{{originCurrentPage}}/{{pageCount}}</span>
          </div>
          <div class="prepage pagebtn" @click="changePdfPage(0)" v-show="btnFlag && pageCount > 1">
            <span class="iconfont icon-zuojiantou-01"></span>
          </div>
          <div class="nextpage pagebtn" @click="changePdfPage(1)" v-show="btnFlag && pageCount > 1">
            <span class="iconfont icon-youjiantou-01"></span>
          </div>
          <div style="padding:20px 60px;">
            <div style="overflow-y: auto;height: 680px;margin-top: 45px;">
              <Pdf
                :src="originsrc"
                :page="originCurrentPage"
                @num-pages="pageCount=$event"
                @page-loaded="originCurrentPage=$event"
                @loaded="loadPdfHandlerex"
              ></Pdf>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="pact_right" @mouseenter="showPageBtn" @mouseleave="hidePageBtn">
          <div class="pact_title">
            {{pactMoudleTitle}}
            <span v-if="targetCurrentPage">{{targetCurrentPage}}/{{pageCountex}}</span>
          </div>
          <div class="prepage pagebtn" @click="changePdfPageex(0)" v-show="btnFlag && pageCountex > 1">
            <span class="iconfont icon-zuojiantou-01"></span>
          </div>
          <div class="nextpage pagebtn" @click="changePdfPageex(1)" v-show="btnFlag && pageCountex > 1">
            <span class="iconfont icon-youjiantou-01"></span>
          </div>
          <div style="padding:20px 60px;">
            <div style="overflow-y: auto;height: 680px;margin-top: 45px;">
              <Pdf
                :src="targetsrc"
                :page="targetCurrentPage"
                @num-pages="pageCountex=$event"
                @page-loaded="targetCurrentPage=$event"
                @loaded="loadPdfHandler"
              ></Pdf>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Pdf from 'vue-pdf'

export default {
  name: 'pactModule',
  props: {
    targetUrl: {
      type: String,
      default: ''
    },
    originUrl: {
      type: String,
      default: ''
    },
    pactMoudleTitle: {
      type: String,
      default: '原合同'
    }
  },
  data () {
    return {
      targetsrc: '',
      originsrc: '',
      btnFlag: false,
      targetCurrentPage: 0, // 盖章合同pdf文件页码
      originCurrentPage: 0, // 原合同pdf文件页码
      pageCount: 0, // pdf文件总页数
      pageCountex: 0, // pdf文件总页数
      fileType: 'pdf' // 文件类型
    }
  },
  watch: {
    // 盖章合同文件路径
    targetUrl: {
      handler (newVal) {
        this.targetsrc = Pdf.createLoadingTask(
          this.$store.state.https + newVal
        )
      }
    },
    // 原合同文件路径
    originUrl: {
      handler (newVal) {
        this.originsrc = Pdf.createLoadingTask(
          this.$store.state.https + newVal
        )
      }
    }
  },
  components: {
    Pdf
  },

  methods: {
    loadPdfHandler (e) {
      this.targetCurrentPage = 1
    },
    loadPdfHandlerex (e) {
      this.originCurrentPage = 1
    },
    changePdfPage (val) {
      if (val === 0 && this.originCurrentPage > 1) {
        this.originCurrentPage--
      }
      if (val === 1 && this.originCurrentPage < this.pageCount) {
        this.originCurrentPage++
      }
    },
    changePdfPageex (val) {
      if (val === 0 && this.targetCurrentPage > 1) {
        this.targetCurrentPage--
      }
      if (val === 1 && this.targetCurrentPage < this.pageCountex) {
        this.targetCurrentPage++
      }
    },
    showPageBtn () {
      this.btnFlag = true
    },
    hidePageBtn () {
      this.btnFlag = false
    }
  }
}
</script>

<style scoped lang="scss">
.pact_left {
  margin-right: 10px;
  height: 780px;
  // height: auto;
  // min-height:1020px;
  background-color: #fff;
  border-radius: 10px;
  /*overflow: auto;*/
  position: relative;
}

.pact_right {
  margin-left: 10px;
  background-color: #fff;
  border-radius: 10px;
  height: 780px;
  // height: auto;
  // min-height:1020px;
  /*overflow: auto;*/
  position: relative;
}

.pact_title {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  text-align: center;
  padding: 20px;
  z-index: 99;
  font-size: 18px;
  color: #4e555b;
  background-color: #fff;
  span {
    font-size: 14px;
    color: #83878a;
  }
}

.pagebtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 88px;
  background: rgba(39, 108, 255, 0.05);
  cursor: pointer;
  text-align: center;
  line-height: 88px;
  color: #276cff;
  z-index: 99;
  font-weight: bolder;
}

.prepage {
  left: 10px;
  border-radius: 10px 0px 0px 10px;

  span {
    padding: 0;
  }
}

.nextpage {
  right: 10px;
  border-radius: 0px 10px 10px 0px;

  span {
    padding: 0;
  }
}
  .iconfont{
    font-size: 28px;
  }
</style>
